import { useI18N } from "@costar-search-x/i18n";
import { useCallback } from "react";
export var useFormatInt = function () {
    var numberOnly = useI18N().common.numberOnly;
    return useCallback(function (value) { return numberOnly({ value: value }); }, [numberOnly]);
};
//# sourceMappingURL=use-format-int.js.map